module.exports = __webpack_public_path__ + "img/logo-eng.308228ee.png";